import { render } from "./MWAboutPage.vue?vue&type=template&id=dbf11538"
import script from "./MWAboutPage.vue?vue&type=script&lang=js"
export * from "./MWAboutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__